<template>
  <div class="search">
    <Card>
      <Row v-show="openSearch" @keydown.enter.native="handleSearch">
        <Form ref="searchForm" :model="searchForm" inline :label-width="70">
          <FormItem label="机构名称" prop="orgName">
            <Input
              type="text"
              v-model="searchForm.orgName"
              placeholder="请输入机构名称"
              clearable
              style="width: 200px"
            />
          </FormItem>
          <FormItem label="机构类型" prop="organizationType">
            <dict
              v-model="searchForm.organizationType"
              dict="机构类型"
              transfer
              style="width: 200px"
            />
          </FormItem>
          <FormItem label="详细地址" prop="address">
            <Input
              type="text"
              v-model="searchForm.address"
              placeholder="请输入详细地址信息"
              clearable
              style="width: 200px"
            />
          </FormItem>
          <FormItem style="margin-left: -35px" class="br">
            <Button @click="handleSearch" type="primary" icon="ios-search"
              >搜索</Button
            >
            <Button @click="handleReset">重置</Button>
            <Button @click="handleRefresh" icon="md-refresh">刷新</Button>
          </FormItem>
        </Form>
      </Row>
      <Row class="operation">
        <!-- <Button @click="add" type="primary" icon="md-add">添加</Button> -->
        <!--        <Button @click="delAll" icon="md-trash">批量删除</Button>-->
        <!-- <Button @click="handleRefresh" icon="md-refresh">刷新</Button> -->
        <!-- <Button type="dashed" @click="openSearch = !openSearch">{{
          openSearch ? "关闭搜索" : "开启搜索"
        }}</Button>
        <Button type="dashed" @click="openTip = !openTip">{{
          openTip ? "关闭提示" : "开启提示"
        }}</Button> -->
      </Row>
      <!-- <Alert show-icon v-show="openTip">
        已选择
        <span class="select-count">{{ selectList.length }}</span> 项
        <a class="select-clear" @click="clearSelectAll">清空</a>
      </Alert> -->
      <Table
        :loading="loading"
        border
        :columns="columns"
        :data="data"
        ref="table"
        sortable="custom"
        @on-sort-change="changeSort"
        @on-selection-change="changeSelect"
      ></Table>
      <Row type="flex" justify="end" class="page">
        <Page
          :current="searchForm.pageNumber"
          :total="total"
          :page-size="searchForm.pageSize"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          :page-size-opts="[10, 20, 50]"
          size="small"
          show-total
          show-elevator
          show-sizer
        ></Page>
      </Row>

      <detail
        :data="form"
        :type="showType"
        v-model="showDrawer"
        @on-submit="getDataList"
      />
    </Card>
    <Modal v-model="downLicenseModal" width="360">
      <p slot="header" style="text-align: center">
        <Icon type="md-cloud-download" />
        <span>证书下载</span>
      </p>
      <div style="text-align: center" width="360">
        <Input
          v-model="licenseVal"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
          placeholder="Enter something..."
        ></Input>
      </div>
      <div slot="footer">
        <a
          :href="'data:application/octet-stream;base64,' + licenseVal"
          target="_blank"
          rel="noopener noreferrer"
          download="keystore.p12"
        >
          <Button
            type="success"
            size="large"
            long
            @on-click="downLicenseModal = false"
            >下载密钥文件
          </Button>
        </a>
      </div>
    </Modal>
    <!-- 菜单权限 -->
    <Drawer
      :title="modalTitle"
      v-model="permModalVisible"
      :mask-closable="false"
      :width="500"
      draggable
    >
      <div :style="{ maxHeight: maxHeight }" class="drawer-content">
        <div style="position: relative">
          <Tree
            ref="tree"
            :data="permData"
            show-checkbox
            :render="renderContent"
          ></Tree>
          <Spin size="large" fix v-if="treeLoading"></Spin>
        </div>
      </div>
      <div class="drawer-footer br">
        <Button
          type="primary"
          :loading="submitPermLoading"
          @click="submitPermEdit"
          >提交
        </Button>
        <Button type="text" @click="cancelPermEdit">取消</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
// 根据你的实际添加编辑组件位置路径修改
import detail from "./detail.vue";
// import dict from "@/views/my-components/jmbase/dict";
import {
  getAllOrgPermissionList,
  getOrgApproveList,
  passOrg,
  rejectOrg,
} from "@/api/index";
import { getStrByApproveType, getStrByActionType } from "@/api/convert";
import { config } from "process";

let dict = window.jinmabasecomponents.components.dict;

export default {
  name: "organization-approve",
  components: {
    detail,
    dict,
  },
  data() {
    return {
      editOrgPermId: "",
      openLevel: "0",
      submitPermLoading: false,
      treeLoading: true,
      permData: [],
      maxHeight: 510,
      permModalVisible: false,
      modalTitle: "",
      licenseVal: "",
      downLicenseModal: false,
      openSearch: true, // 显示搜索
      openTip: true, // 显示提示
      showType: "0", // 添加或编辑标识
      showDrawer: false, // 显示添加编辑抽屉
      loading: true, // 表单加载状态
      searchForm: {
        // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "createTime", // 默认排序字段
        order: "desc", // 默认排序方式
      },
      selectList: [], // 多选数据
      form: {},
      columns: [
        {
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "机构名称",
          key: "orgName",
          minWidth: 120,
          sortable: false,
          renderHeader: (h, params) => {
            var h1 = h("span", params.column.title);
            var that = this;
            if (this.columns[params.index].$isEdit) {
              let inputE = document.getElementById(
                params.column.key + "_input"
              );
              if (inputE != null) {
                inputE.focus();
              }
              h1 = h("input", {
                domProps: {
                  value: params.column.title,
                  id: params.column.key + "_input",
                },
                on: {
                  input: function (event) {
                    params.column.title = event.target.value;
                  },
                  blur: function (event) {
                    that.columns[params.index].$isEdit = false;
                    that.columns[params.index].title = "";
                    that.columns[params.index].title = event.target.value;
                  },
                },
                style: { width: params.column.minWidth - 18 + "px" },
                class: "ivu-input ivu-input-default",
              });
            }
            return h("div", [
              h1,
              h("Icon", {
                props: {
                  type: "md-color-filter",
                  color: "#c5c8ce",
                },
                style: {
                  padding: "0px 0px 0px 5px",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.columns[params.index].$isEdit = true;
                    let title = this.columns[params.index].title;
                    this.columns[params.index].title = "";
                    this.columns[params.index].title = title;
                  },
                },
              }),
            ]);
          },
        },
        {
          title: "过期时间",
          key: "expireTime",
          minWidth: 160,
          sortable: true,
          render: (h, params) => {
            let timeDate = params.row.expireTime.replace(/\-/g, "/");
            var dayTime = new Date();
            var expireTime = Date.parse(timeDate);
            var props = {};
            props["text"] = params.row.expireTime;
            props["overflowCount"] = "11";
            if (dayTime.getTime() < expireTime) {
              props["status"] = "Default";
            } else {
              props["status"] = "error";
            }
            return h("div", [
              h("Badge", {
                props: props,
              }),
            ]);
          },
        },
        {
          title: "机构类型",
          key: "organizationTypeName",
          minWidth: 120,
          sortable: true,
        },
        {
          title: "租户名称",
          key: "tenantName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "详细地址信息",
          key: "address",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "描述信息",
          key: "description",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "申请人",
          key: "createByName",
          minWidth: 120,
          sortable: false,
        },
        // {
        //   title: "审核人",
        //   key: "updateByName",
        //   minWidth: 120,
        //   sortable: false,
        // },
        // {
        //   title: "申请操作",
        //   minWidth: 120,
        //   sortable: false,
        //   render: (h, params) => {
        //     let re = getStrByActionType(params.row.action);
        //     let color = "#c5c8ce";
        //     return h("div", [
        //       h(
        //         "div",
        //         {
        //           props: {
        //             color: color,
        //           },
        //         },
        //         re
        //       ),
        //     ]);
        //   },
        // },
        {
          title: "状态",
          key: "status",
          minWidth: 120,
          sortable: false,
          render: (h, params) => {
            let re = getStrByApproveType(params.row.approveStatus);
            let color = "#c5c8ce";
            return h("div", [
              h(
                "div",
                {
                  props: {
                    color: color,
                  },
                },
                re
              ),
            ]);
          },
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 250,
          render: (h, params) => {
            let btnList = [
              h(
                "a",
                {
                  on: {
                    click: () => {
                      this.detail(params.row);
                    },
                  },
                },
                "详情"
              ),
            ];
            return h("div", btnList);
          },
        },
      ],
      data: [], // 表单数据
      pageNumber: 1, // 当前页数
      pageSize: 10, // 页面大小
      total: 0, // 表单数据总数
    };
  },
  methods: {
    getPermList() {
      this.treeLoading = true;
      getAllOrgPermissionList().then((res) => {
        if (res.success) {
          this.deleteDisableNode(res.result);
          this.permData = res.result;
          this.treeLoading = false;
        }
        this.treeLoading = false;
      });
    },
    // 递归标记禁用节点
    deleteDisableNode(permData) {
      let that = this;
      permData.forEach(function (e) {
        if (e.status == -1) {
          e.title = "[已禁用] " + e.title;
          e.disabled = true;
        }
        if (e.children && e.children.length > 0) {
          that.deleteDisableNode(e.children);
        }
      });
    },
    cancelPermEdit() {
      this.permModalVisible = false;
    },
    changeOpen(v) {},
    // 全选反选
    selectTreeAll() {},
    submitPermEdit() {
      let permIds = "";
      let selectedNodes = this.$refs.tree.getCheckedNodes();
      selectedNodes.forEach(function (e) {
        permIds += e.id + ",";
      });
      permIds = permIds.substring(0, permIds.length - 1);
      this.postRequest(
        "/api/rest/operation/orgRelationPermission/saveOrgRelationPermission",
        { orgId: this.editOrgPermId, permIds: permIds }
      ).then((res) => {
        this.submitPermLoading = false;
        if (res.success) {
          this.getDataList();
          this.$Message.success("操作成功");
          this.permModalVisible = false;
        }
      });
    },
    renderContent(h, { root, node, data }) {
      let icon = "";
      if (data.level == 0) {
        icon = "ios-navigate";
      } else if (data.level == 1) {
        icon = "md-list-box";
      } else if (data.level == 2) {
        icon = "md-list";
      } else if (data.level == 3) {
        icon = "md-radio-button-on";
      } else {
        icon = "md-radio-button-off";
      }
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            cursor: "pointer",
          },
          on: {
            click: () => {
              data.checked = !data.checked;
            },
          },
        },
        [
          h("span", [
            h("Icon", {
              props: {
                type: icon,
                size: "16",
              },
              style: {
                "margin-right": "8px",
                "margin-bottom": "3px",
              },
            }),
            h("span", data.title),
          ]),
        ]
      );
    },
    editPerm(v) {
      this.permModalVisible = true;
      this.editOrgPermId = v.id;
      // this.modalTitle = "分配 " + v.name + " 的菜单权限";
      // 匹配勾选
      let rolePerms = v.orgRelationPermissionVOS;
      if (this.treeLoading) {
        this.$Message.warning("菜单权限数据加载中，请稍后点击查看");
        return;
      }
      // 递归判断子节点
      this.checkPermTree(this.permData, rolePerms);
    },
    checkPermTree(permData, rolePerms) {
      let that = this;
      permData.forEach(function (p) {
        if (that.hasPerm(p, rolePerms) && p.status != -1) {
          p.checked = true;
        } else {
          p.checked = false;
        }
        if (p.children && p.children.length > 0) {
          that.checkPermTree(p.children, rolePerms);
        }
      });
    },
    // 判断角色拥有的权限节点勾选
    hasPerm(p, rolePerms) {
      let flag = false;
      for (let i = 0; i < rolePerms.length; i++) {
        if (p.id == rolePerms[i].orgPermissionId) {
          flag = true;
          break;
        }
      }
      if (flag) {
        return true;
      }
      return false;
    },
    downLicense(row) {
      let params = {};
      params["jmbaseReqUrl"] = config.resourceCenterApi;
      console.log("downLicense ", params);
      this.getRequest(
        "/api/rest/operation/organization/" + row.id + "/license",
        params
      ).then((res) => {
        this.licenseVal = "";
        if (res.success) {
          this.downLicenseModal = true;
          this.licenseVal = res.result;
        }
      });
    },
    init() {
      this.getDataList();
      // this.getPermList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      // 重新加载数据
      this.getDataList();
    },
    handleRefresh() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
    },
    getDataList() {
      this.loading = true;
      getOrgApproveList(this.searchForm).then((res) => {
        this.loading = false;
        if (res.success) {
          this.data = res.result.records;
          this.total = res.result.total;
          if (this.data.length == 0 && this.searchForm.pageNumber > 1) {
            this.searchForm.pageNumber -= 1;
            this.getDataList();
          }
        }
      });
      this.total = this.data.length;
      this.loading = false;
    },
    detail(v) {
      // 转换null为""

      for (let attr in v) {
        if (v[attr] == null) {
          if (attr == "orgRelationPermissionVOS") {
            v[attr] = {};
          } else {
            v[attr] = "";
          }
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      if (data.jsonData) {
        data.jsonData = JSON.parse(data.jsonData);
      } else {
        data.jsonData = "";
      }
      this.form = data;
      this.showType = "1";

      this.showDrawer = true;
    },
    pass(v) {
      this.$Modal.confirm({
        title: "确认通过",
        // 记得确认修改此处
        content: "您确认通过审核该条数据?",
        loading: true,
        onOk: () => {
          // 删除
          passOrg({ id: v.id }).then((res) => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.clearSelectAll();
              this.getDataList();
            }
          });
        },
      });
    },
    reject(v) {
      this.$Modal.confirm({
        title: "确认驳回",
        // 记得确认修改此处
        content: "您确认要驳回该条数据?",
        loading: true,
        onOk: () => {
          // 删除
          rejectOrg({ id: v.id }).then((res) => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.clearSelectAll();
              this.getDataList();
            }
          });
        },
      });
    },
  },
  mounted() {
    this.maxHeight = Number(document.documentElement.clientHeight - 121) + "px";
    this.init();
  },
};
</script>
<style lang="less">
// 建议引入通用样式 具体路径自行修改 可删除下面样式代码
// @import "@/styles/table-common.less";
.search {
  .operation {
    margin-bottom: 2vh;
  }

  .select-count {
    font-weight: 600;
    color: #40a9ff;
  }

  .select-clear {
    margin-left: 10px;
  }

  .page {
    margin-top: 2vh;
  }

  .drop-down {
    margin-left: 5px;
  }
}
</style>
